import React from 'react'
import { styled } from 'linaria/react'

const ArticlesHeaderAltContainer = styled.div`
   h2 {
      font-size: calc(1vw + 1.2rem);
   }
`

const ArticlesHeaderAlt = ({ title }) => {
   return (
      <ArticlesHeaderAltContainer className="row seperator d-flex align-items-center mb-32 pt-32">
         <div className="col d-md-block">
            <hr />
         </div>
         <div className="col-auto">
            <h2>{title}</h2>
         </div>
         <div className="col d-md-block">
            <hr />
         </div>
      </ArticlesHeaderAltContainer>
   )
}

export default ArticlesHeaderAlt
